export enum AcceptanceValidationTypeEnum {
    Tree = 'BOOM',
    None = 'GEEN',
}
